import { useContext } from "react";
import { AuthContext } from "../../context/authContext";
import HomeSection from "../organisms/sections/home/HomeSection";
import AppContent from "../templates/wrapper/AppContent";
import MobileBanner from "../molecules/layouts/app/MobileBanner";

export default function Home() {
  const { attrInfo } = useContext(AuthContext);

  return (
    <>
      <MobileBanner />
      <AppContent contentOverBanner>
        <HomeSection attrInfo={attrInfo} />
      </AppContent>
    </>
  );
}
